type TFilterGroup = 'city' | 'village';

export interface IFilterItem {
    value: string | number,
    label: string,
    checked?: boolean,
}

export interface IFilterSubGroup {
    name: string,
    label: string,
    items: Array<IFilterItem>,
}

export interface IFilterGroup {
    name: string,
    items: Array<IFilterSubGroup>,
}

export type TFilters = {
    [key in TFilterGroup]: IFilterGroup;
};

export interface ISelectedFilters {
    group: TFilterGroup,
    name: string,
    values: Array<string | number>,
}

export interface IFilterProp {
    [key: string]: string[] | string | undefined,
}

export enum SwitcherItemsText {
    apartment = 'Для квартиры',
    village = 'Для частного дома',
}

export enum FiltersName {
    speed = 'speed',
    lineId = 'lineId',
    type = 'type',
    campaign = 'campaign',
    sortBy = 'sortBy',
}

export enum FiltersTitle {
    speed = 'Скорость интернета',
    lineId = 'Для чего тариф',
    type = 'Мне нужно',
    campaign = 'Акции',
    sortBy = 'Показывать сначала',
}

export enum SortByValues {
    recommended = 'recommended',
    cheap = 'cheap',
    expensive = 'expensive',
}

export enum SortByLabels {
    recommended = 'Популярные',
    cheap = 'Дешевле',
    expensive = 'Дороже',
}

export const CampaignFilterValues: Record<string, string> = {
    priceAction: 'priceAction',
    equipment: 'hasRequiredEquipment',
};

export const CampaignFilterLabels: Record<string, string> = {
    priceAction: 'Скидка на первые месяцы',
    equipment: 'Оборудование в тарифе',
};

export const TypeFilterLabels: Record<string, string> = {
    bundles: 'С телевидением',
    internet: 'Только интернет',
};

export const selectedFiltersInitial: Array<ISelectedFilters> = [
    { group: 'city', name: 'speed', values: [] },
    { group: 'city', name: 'lineId', values: [] },
    { group: 'city', name: 'type', values: [] },
    { group: 'city', name: 'campaign', values: [] },
    { group: 'village', name: 'speed', values: [] },
    { group: 'village', name: 'lineId', values: [] },
    { group: 'village', name: 'type', values: [] },
    { group: 'village', name: 'campaign', values: [] },
];

export const filtersItemsInitial: TFilters = {
    city: {
        name: 'Для квартиры',
        items: [
            {
                name: 'speed',
                label: 'Скорость интернета',
                items: [],
            },
            {
                name: 'lineId',
                label: 'Для чего тариф',
                items: [],
            },
            {
                name: 'type',
                label: 'Мне нужно',
                items: [],
            },
            {
                name: 'campaign',
                label: 'Акции',
                items: [],
            },
        ],
    },
    village: {
        name: 'Для частного дома',
        items: [
            {
                name: 'speed',
                label: 'Скорость интернета',
                items: [],
            },
            {
                name: 'lineId',
                label: 'Для чего тариф',
                items: [],
            },
            {
                name: 'type',
                label: 'Мне нужно',
                items: [],
            },
            {
                name: 'campaign',
                label: 'Акции',
                items: [],
            },
        ],
    },
};

export const sortedItemsInitial: IFilterSubGroup = {
    name: FiltersName.sortBy,
    label: FiltersTitle.sortBy,
    items: [
        {
            value: SortByValues.recommended,
            label: SortByLabels.recommended,
            checked: true,
        },
        {
            value: SortByValues.cheap,
            label: SortByLabels.cheap,
            checked: false,
        },
        {
            value: SortByValues.expensive,
            label: SortByLabels.expensive,
            checked: false,
        },
    ],
};
